export default "__VITE_ASSET__jYpDf56n__"